import $ from 'jquery'
import 'slick-carousel'
export default () => {

  var $slider = $('.js-slider');

    // JS Carousel Slider
    $(document).find('.js-slider:not(.slick-initialized)').each(function () {

    var $slider = $(this);
    const options = getSlickOptions($slider);

    // custom innerblocks slider
    var $carousel = $slider.children('.acf-innerblocks-container');
    var $slides = $carousel.children('.block-carousel-slide');

    if (!$carousel.length) {
        return;
    }

    if ($slider.hasClass('slick-initialized')) {
      $carousel.slick('unslick');
      $slider.removeClass('slick-initialized');
    }

    if ($slides.length <= 1) return;

    $carousel.slick({
        ...options
    });

    $slider.addClass('slick-initialized');

  });

  function getSlickOptions($el) {
      const raw = $el.attr('data-slick');

      if (!raw) return {};

      try {
          return JSON.parse(raw);
      } catch (e) {
          console.error('Invalid data-slick JSON', e);
          return {};
      }
  }
}